import { render, staticRenderFns } from "./TheHeaderDropdownAccount.vue?vue&type=template&id=1df36eaf&"
import script from "./TheHeaderDropdownAccount.vue?vue&type=script&lang=ts&"
export * from "./TheHeaderDropdownAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports